import React from "react";
import { Navigate } from "react-router-dom";
import Homepage from "./Homepage";
import { useIsNewLayout } from "../../services/SettingsContext";

// The /web landing route. When the platform version selects the redesigned
// layout (see useIsNewLayout), redirect to the isolated /web/v2 tree so existing
// /web routing is untouched; otherwise render the existing homepage.
export default function HomepageSwitcher() {
  return useIsNewLayout() ? <Navigate to="/web/v2" replace /> : <Homepage />;
}
